import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { PAGE_LAYOUT } from '../../../src/shared/pageTypes';
import SectionList from '../../../src/admin/modules/pageBuilder/components/SectionList';
import CurrentPageProvider from '../../../src/web/modules/Page/containers/CurrentPageServerProvider';
import useLayoutEditor from '../../hooks/useLayoutEditor';

const propTypes = {
  pageLayout: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  onAddVersion: PropTypes.func.isRequired,
  version: PropTypes.shape({
    sections: PropTypes.array.isRequired,
  }).isRequired,
};

const defaultProps = {};

const Builder = ({
  pageLayout,
  version,
  onAddVersion,
}) => {
  const [
    state,
    {
      onSectionEditStart,
      onSectionEditStop,
      onWidgetEditStart,
      onWidgetEditStop,
    },
  ] = useLayoutEditor();

  const layoutSections = version ? version.sections : [];

  return (
    <CurrentPageProvider>
      <SectionList
        sections={layoutSections}
        layout={pageLayout}
        isSectionBeingEdited={section => state.editingSections[section.id]}
        isWidgetBeingEdited={id => state.editingWidgets[id]}
        onWidgetEditStart={onWidgetEditStart}
        onWidgetEditStop={onWidgetEditStop}
        onSectionEditStart={onSectionEditStart}
        onSectionEditStop={onSectionEditStop}
        onUpdate={onAddVersion}
        pageType={PAGE_LAYOUT}
        sectionIsDragging={state.sectionIsDragging}
        legacyWidgetLoader={false}
      />
    </CurrentPageProvider>
  );
};

Builder.propTypes = propTypes;
Builder.defaultProps = defaultProps;

Builder.fragments = {
  version: gql`
    fragment BuilderVersion on Version {
      sections {
        id
        type
        payload
        data
        widgets {
          id
          type
          payload
          componentId
        }
      }
    }
  `,
};

export default Builder;
